import { NotificationDetailQueue } from "api/resources/models/AutoGenerated";
import { SortOrder } from "api/resources/models/User";
import { MessageQueueParams } from "../types";

export function useMessageQueueParams(url: string): MessageQueueParams {
  const urlParams = new URLSearchParams(url);

  const sort = urlParams.get('sort');
  const sortOrder = urlParams.get('sortDirection') as SortOrder;
  const searchValue = urlParams.get('searchValue');
  return {
    sortString: sort as keyof NotificationDetailQueue,
    sortOrder: Object.values(SortOrder).includes(sortOrder) ? sortOrder : null,
    searchValue: searchValue || '',
  };
}